<template>
  <app-modal :model-value="true"
             :ok-text="$t('common.confirm')"
             size="md"
             @ok="confirm"
             @cancel="closeDialog"
  >
    <template #title>{{ $t('project.signing-checklist.dialogs.SignerOrderSignatureTypeIncompatibilityWarningDialog.title') }}</template>

    <template #body>
      <p>{{ $t('project.signing-checklist.dialogs.SignerOrderSignatureTypeIncompatibilityWarningDialog.warning') }}</p>
    </template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'
export default {
  name: 'SignerOrderSignatureTypeIncompatibilityWarningDialog',
  mixins: [dialogMixin],
  methods: {
    confirm () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
